<template>
  <div class="checkbox__wrapper">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0246 11.9999C23.0246 5.91091 18.0885 0.974854 11.9996 0.974854C5.91067 0.974854 0.974609 5.91091 0.974609 11.9999C0.974609 18.0888 5.91067 23.0249 11.9996 23.0249C18.0885 23.0249 23.0246 18.0888 23.0246 11.9999Z"
        :stroke="modelValue ? '#F0783B' : '#8290A3'"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        v-if="modelValue"
        d="M16.0546 9.34835L10.7513 14.6517L8.09961 12"
        stroke="#F0783B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span
      class="checkboxLabel"
      :class="modelValue ? 'is-active' : ''"
      v-if="label"
      >{{ label }}</span
    >
  </div>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin],
  props: ["modelValue", "label", "defaultValue"]
};
</script>
<style>
.checkbox__wrapper {
  display: flex;
  align-items: center;
}
.checkbox__wrapper svg {
  margin-right: 10px;
}
.checkboxLabel {
  color: #8290a3;
  font-weight: 600;
}
.checkboxLabel.is-active {
  color: #f0783b;
}
</style>
